import { NgModule } from '@angular/core'
import { NewDispenserCreditRequestModule } from './new-dispenser-credit-request/new-dispenser-credit-request.module'

@NgModule({
  imports: [NewDispenserCreditRequestModule]
})
export class DispenserCreditRequestModule {}
